import { REBRANDING_TOGGLE } from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const isRebrandingActive = (experiments: Experiment[] = []): boolean => {
  const [experiment] = getExperiments([REBRANDING_TOGGLE], experiments)
  return Boolean(experiment?.isEnabled)
}
